export default __webpack_public_path__ + "static/media/fa-brands-400.d5a5eb19.woff2";